import { CashFlowImpl } from "../data/CashFlowImpl";
import { ICashFlowRepository } from "../domain/repositories/ICashFlowRepository";
import { CashFlowUseCase } from "../domain/useCases/CashFlowUseCase";
import { CashFlowViewModel } from "../presentation/viewModel/CashFlowViewModel";
import { InjectionBinding, InjectionModule } from "app/di/DependencyInjections";

export class CashFlowInjection extends InjectionModule {
  private static readonly cashFlowRepositoryToken = Symbol(
    "ICashFlowRepository",
  );
  private static readonly cashFlowUseCaseToken = Symbol("CashFlowUseCase");
  private static readonly cashFlowViewModelToken = Symbol("CashFlowViewModel");

  protected static override bindings: InjectionBinding[] = [
    {
      scope: "otherRepo",
      token: this.cashFlowRepositoryToken,
      useClass: CashFlowImpl,
    },
    {
      scope: "otherRepo",
      token: this.cashFlowUseCaseToken,
      useClass: CashFlowUseCase,
    },
    {
      scope: "viewModel",
      token: this.cashFlowViewModelToken,
      useClass: CashFlowViewModel,
    },
  ];

  static getRepo(): ICashFlowRepository {
    return this.resolve(this.cashFlowRepositoryToken);
  }

  static getUseCase(): CashFlowUseCase {
    return this.resolve(this.cashFlowUseCaseToken);
  }
}
